(function () {
  'use strict';

  angular
    .module('web2print')
    .run(checkBrowserSupport)
    .run(checkLocalStorageAvailability)
    .run(checkIfNCP)
    .run(runBlock)
    .run(setMarket)
    .run(setRedirectionOnLoginLogout)
    .run(setDateLoaded)
    .run(checkSavedCampaign);
  // .run(pushToGTM);

  checkBrowserSupport.$inject = ['$rootScope'];
  checkIfNCP.$inject = ['$location', '$rootScope', 'recipientsFactory', '$localStorage', '$window'];
  setRedirectionOnLoginLogout.$inject = ['Common', '$location', '$rootScope'];
  setMarket.$inject = ['appOptions', 'Common', '$rootScope'];
  checkSavedCampaign.$inject = ['Common'];
  // pushToGTM.$inject = ['$rootScope', '$window', '$localStorage'];

  /** @ngInject */
  function checkBrowserSupport ($rootScope) {
    console.log('checkBrowserSupport');
    $rootScope.unsupportedBrowser = isIE() && isIE() <= 10;
  }

  checkLocalStorageAvailability.$inject = ['$localStorage', '$rootScope'];
  /** @ngInject */
  function checkLocalStorageAvailability ($localStorage, $rootScope) {
    const hasStorage = (function () {
      try {
        localStorage.setItem('mod', 'mod');
        localStorage.removeItem('mod');
        return true;
      } catch (exception) {
        return false;
      }
    }());
    $rootScope.localStorageDisabled = !hasStorage;
  }

  /** @ngInject */
  function runBlock ($log, $rootScope, $localStorage, $state, $translate, $document, $window, Common) {
    const marketSites = {
      SE: web2print.env.ncpDirectmailUrl
    };

    $rootScope.$on('$stateChangeSuccess', function () {
      $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
    });

    if (angular.isDefined(pnTopbar)) {
      pnTopbar.onChangeLanguage = function (language) {
        console.log('Run: Switching to language ' + language);
        $translate.use(language);
        $rootScope.language = language;
        $rootScope.$digest();

        // Update humany widget
        $rootScope.$broadcast('changeLanguage', language);
      };

      pnTopbar.onChangeMarket = function (market) {

        const urlKeywords = {
          SE: {
            0: 'skapa-utskick',
            1: 'skapa-utskick'
          }
        };
        console.log('Run: Switching to market ' + market);
        // for dev env
        if ($window.location.href.indexOf('localhost') > -1) {
          $rootScope.market = market;
        } else {
          // this is to fix the issue on redirectiing on reload
          const url = $window.location.href;
          if (url.indexOf(urlKeywords[pnTopbar.market][Number($rootScope.isNCPUser())]) < 0) {
            $window.location = marketSites[market];
          }
        }

      };
    } else {
      console.warn('Could not find pnTopbar, using \'en\' as language');

      $translate.use('en');
      $rootScope.language = 'en';
    }

    $log.debug('runBlock end');
  }

  function isIE () {
    const sAgent = window.navigator.userAgent;
    const Idx = sAgent.indexOf('MSIE');

    // If IE, return version number.
    if (Idx > 0) {
      return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));
    }

    // If IE 11 then look for Updated user agent string.
    else if (sAgent.match(/Trident\//)) {
      const rv = sAgent.indexOf('rv:');
      return parseInt(sAgent.substring(rv + 3, sAgent.indexOf('.', rv)), 10);
    }

    // If EDGE IE 12+
    else if (sAgent.match(/Edge\//)) {
      const edge = sAgent.indexOf('Edge/');
      return parseInt(sAgent.substring(edge + 5, sAgent.indexOf('.', edge)), 10);
    }

    else {
      return 0; //It is not IE
    }
  }

  function isBusinessUser () {
    return pnTopbar.isLoggedIn && (pnTopbar.isBusinessUser || (window.pnTopbar.user && window.pnTopbar.user.user_type_id === '1'));
  }

  function checkIfNCP ($location, $rootScope, recipientsFactory, $localStorage, $window) {
    $rootScope.baseUrl = $location.$$absUrl.slice(0, $location.$$absUrl.indexOf('/#/'));
    $rootScope.bgId = 'background_wrap';

    $rootScope.isNCPUser = function () {
      if (typeof (pnTopbar) !== 'undefined') {
        return isBusinessUser();
      }
    };

    $rootScope.isPublicUserOrAnonymous = function () {
      return (pnTopbar.isLoggedIn && !isBusinessUser()) || !pnTopbar.isLoggedIn;
    };

    $rootScope.isAuthorizedToAccessService = function () {
      if (typeof (pnTopbar) !== 'undefined') {
        return $rootScope.isPublicUserOrAnonymous() ||
          web2print.env.serviceAuthorityIDs.some(id =>
            pnTopbar.user.authoritylist.includes(id)
          );
      }
    };

    function deleteProductDelivery () {
      if ($localStorage && $localStorage.productDelivery) {
        delete $localStorage.productDelivery;
      }
    }

    $rootScope.isNCP = $rootScope.isNCPUser();
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = web2print.env.sideMenuUrl;
    document.getElementsByTagName('body')[0].appendChild(script);

    if (pnTopbar.isLoggedIn) {
      if ($rootScope.isNCPUser()) {
        if (!$rootScope.isAuthorizedToAccessService()) {
          $window.location = web2print.env.landingPageUrl;
          return;
        }

        if (!$rootScope.isNCP && pnTopbar.market === 'SE' && $location.$$absUrl.indexOf('localhost') < 0) {
          $window.location = web2print.env.ncpDirectmailUrl;
          return;
        }

        recipientsFactory.isNCP = true;
        $rootScope.bgId = 'background_wrap_ncp';
        $rootScope.correctLogin = true;
      } else {
        if ($rootScope.isNCP && pnTopbar.market === 'SE' && $location.$$absUrl.indexOf('localhost') < 0) {
          deleteProductDelivery();
          $window.location = web2print.env.publicDirectmailUrl;
          return;
        }

        $rootScope.bgId = 'background_wrap_ncp';
        $rootScope.correctLogin = true;
      }
    } else {
      if ($rootScope.isNCP) {
        // force user to login
        pnTopbar.login();
        return;
      }
      $rootScope.isNCP = $rootScope.isNCPUser();

      $rootScope.bgId = 'background_wrap_ncp';
      $rootScope.correctLogin = true;
    }

    // End


    // This block is for development on local machine, especially when you don't want to login
    // comment this when not working on ncp menu,
    // comment this when commiting

    // $rootScope.isNCP = recipientsFactory.isNCP = true;
    // $rootScope.correctLogin = true;
    // var script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = 'https://atportal.postnord.com/ncpmenu/mainMenu';
    // $rootScope.bgId = 'background_wrap_ncp';
    // document.getElementsByTagName('body')[0].appendChild(script);

    // End
  }

  function setDateLoaded (authFactory) {
    authFactory.setDateLoaded();
  }

  function setRedirectionOnLoginLogout (Common, $location, $rootScope, $state) {
    pnTopbar.onCachedRedirectUrlDetected = function (url) {
      // so that it won't conflict with redirection when session expires
      if (!Common.get('pageBeforeLogin', false) && pnTopbar.isLoggedIn) {
        window.location.replace(url);
      }
    };

    pnTopbar.onLogout = function () {
      Common.set('userProfile', null);

      if (Common.get('recipients', false) || Common.get('senderInfo', false)) {
        Common.resetOrderData();
      }
      console.log($state);
      if ($state && $state.current.name === 'main.landing') {
        Common.notifyObserver('resetOrderHistoryPreview');
      }

      // redirect to login regardless on the user type
      pnTopbar.login();

      // commenting out these for now.
      // if ($rootScope.isNCP) {
      //   pnTopbar.login();
      //   return;
      // }

      $state.go('main.landing');
    };
  }

  function setMarket (appOptions, Common, $rootScope) {
    appOptions.country = Common.getAppCountry();
    if (typeof (pnTopbar) !== 'undefined') {
      const markets = Object.keys(web2print.env.baseUrls)
        .map(function (market) {
          return market.toUpperCase();
        });

      if (!markets.includes(appOptions.country)) {
        pnTopbar.market = 'SE'; // Set default to SE if market is not supported
        window.location.reload();
        return;
      }

      pnTopbar.markets = markets;
      pnTopbar.market = appOptions.country;
      $rootScope.market = appOptions.country;
    }
  }

  /**
   * Check saved campaign if uploaded files are within the TTL set on s3
   * If more than the TTL, reset order data
   */
  function checkSavedCampaign (Common) {
    const now = moment();
    const s3FileTtlDays = 29;
    const addressesDateTime = Common.get('uploadDateTime.addresses', false);
    const pdfDateTime = Common.get('uploadDateTime.pdf', false);
    const addressesExpired = addressesDateTime && now.diff(addressesDateTime, 'days') > s3FileTtlDays;
    const pdfExpired = pdfDateTime && now.diff(pdfDateTime, 'days') > s3FileTtlDays;

    if (addressesExpired || pdfExpired) {
      Common.resetOrderData();
    }
  }

})();
